export type TagResponse = {
  connectedAsset: string;
  dataType: string;
  displayName: string;
  gatewayId: string;
  gatewayName?: string;
  hidden: boolean;
  siteName?: string;
  id: string;
  rawInputName: string;
  rawUnit: string;
  connectedAssetId: string;
  forwarded?: boolean;
  siteForwardedFrom?: string;
  gatewayForwardedFrom?: string;
  parentType?: string;
  value?: string | number;
  fallbackValue: string;
};

export enum LabelingTypeEnum {
  VALUE = 'value',
  LABEL = 'label',
  VALUE_LABEL = 'value_label',
}

export enum TagIndicatorTypes {
  StateOn = 'StateOn',
  StateOff = 'StateOff',
  AlarmOn = 'AlarmOn',
  AlarmOff = 'AlarmOff',
  Info = 'Info',
  Warning = 'Warning',
  Critical = 'Critical',
  Cleared = 'Cleared',
  Offline = 'Offline',
}

export enum TagDisplayTypeEnum {
  ALARM_INDICATOR = 'alarm_indicator',
  ASSET_STATE_INDICATOR = 'asset_state_indicator',
  VALUE_INDICATOR = 'value_indicator',
}
